import React from 'react';

const NotificationDialog = ({ open, message, onClose }) => {
  if (!open) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999
    }}>
      <div style={{
        background: '#fff',
        padding: '24px 32px',
        borderRadius: 8,
        boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
        minWidth: 300,
        textAlign: 'center'
      }}>
        <div style={{ fontSize: 18, marginBottom: 16 }}>{message}</div>
        <button
          onClick={onClose}
          style={{
            padding: '8px 24px',
            background: '#1976d2',
            color: '#fff',
            border: 'none',
            borderRadius: 4,
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default NotificationDialog;
